<script setup>

import moment from "moment/moment";
import { onMounted, onBeforeUnmount, ref, watch } from "vue";
import { copyRichTextSelection } from "@/utils/copyRichTextSelection";
import { renderQuillComment } from "@/utils/renderQuillComment";

// eslint-disable-next-line no-unused-vars
const props = defineProps({
    message: {
      type: Object,
      required: true
    },
    editable: {
      type: Boolean,
      default: false
    }
  })

const emit = defineEmits(["edit"])

const commentContainer = ref(null);
const renderedComment = ref(null);

const prepareCommentDisplay = (quill) => {
  renderedComment.value = renderQuillComment(quill, props.message.comment);
};

watch(() => props.message.comment, () => {
  renderedComment.value = null;
});
const copyComment = (event) => {
  copyRichTextSelection(event, commentContainer.value?.querySelector(".ql-editor"));
};

onMounted(() => document.addEventListener("copy", copyComment));
onBeforeUnmount(() => document.removeEventListener("copy", copyComment));


  const formatDateTime = (value) => {
    if (value) {
      return moment(value).format("DD/MM/YYYY");
    }
    return "";
  }

</script>

<template>
  <div class="container m-0 p-0 t-message">
    <p>
      <span class="message-author">{{ message.author }}</span>
      <span class="message-date"> {{ formatDateTime(message.createdAt) }}</span>
      <span v-if="editable" class="message-edit pointer" @click="emit('edit', message)">Editar</span>
    </p>
    <div ref="commentContainer" class="message-comment">
      <!-- Quill normalizes HTML once; published comments use ordinary selectable markup. -->
      <QuillEditor
        v-if="renderedComment === null"
        contentType="html"
        class="quillNew"
        theme=""
        :readOnly="true"
        @ready="prepareCommentDisplay"
      />
      <div v-else class="quillNew ql-container">
        <div class="ql-editor" v-html="renderedComment" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  p{
    padding-bottom: 1px!important;
    margin-bottom: 0!important;
  }
  .message-date {
    color: red;
    font-family: "Montserrat";
    font-size: 20px;
  }
  .message-author {
    font-family: "Montserrat";
    font-weight: 700;
    font-size: 20px;
    margin-right: 5px;
  }
  .message-edit {
    color: $bg-blue;
    font-family: "Montserrat";
    font-size: 14px;
    font-weight: 600;
    margin-left: 8px;
    text-decoration: underline;
  }
  .message-comment {
    font-family: "Montserrat";
    font-size: 20px;
    padding-top: 0!important;
  }
  // Keep read-only comments selectable, including their rich-text content.
  .message-comment :deep(.ql-editor),
  .message-comment :deep(.ql-editor *) {
    -webkit-user-select: text;
    user-select: text;
  }
  .t-message {
    border-bottom: 1px solid;
    margin-bottom: 15px!important;
  }
</style>
